import request from '@/utils/request';

/**
 * 获取审批流列表
 */
export function getCompanyTypes() {
  return request({
    url: '/api/company/type-permission',
    method: 'get'
  });
}

/**
 * 创建公司信息
 */
export function createCompanyInfo(data) {
  return request({
    url: '/api/company/info',
    method: 'post',
    data
  });
}

/**
 * 修改公司信息
 */
export function putCompanyInfo(company_id, data) {
  return request({
    url: '/api/company/info',
    method: 'put',
    params: { company_id },
    data
  });
}


/**
 * 获取公司列表
 */
 export function getCompanyList(params) {
  return request({
    url: '/api/company',
    method: 'get',
    params
  });
}


/**
 * 获取公司列表
 */
 export function getCompanyDetail(company_id) {
  return request({
    url: '/api/company/detail',
    method: 'get',
    params: { company_id }
  });
}

